import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const getPathSegments = (path: string) =>
  path.replace(/\/$/, '').split('/').filter(Boolean)

const calculateStepsBack = (segments: string[]) =>
  Math.max(segments.length - 1, 1)

export function useBackNavigation() {
  const location = useLocation()
  const navigate = useNavigate()

  const goBack = React.useCallback(() => {
    // prettier-ignore
    const steps = calculateStepsBack(
      getPathSegments(location.pathname)
    )

    // if we are in deeper
    if (steps > 1) return navigate('/reimbursements')
    navigate(-steps)
  }, [location.pathname, navigate])

  return goBack
}
